// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__BzIjk","file":"styles_file__2pIRG"};